import { EncryptionService } from '@morningstar/shared/encryption';
import { TokenService } from '@morningstar/shared/auth';
import { Injectable } from '@angular/core';
import { SecurityGroups } from '@morningstar/shared/auth';
import { SecurityGroupAuthorization } from '../navigation-guard/security-group-authorization';

@Injectable()
export class RouteValidationService {

  constructor(private tokenService: TokenService) { }

  validateRoute(path: string): boolean {
    const routes = this.tokenService.getRoutes();

    if (!routes) {
      return false;
    }

    return routes[EncryptionService.encrypt(path)] != null;
  }

  validateSecurityGroup(targetSecurityGroup: SecurityGroups, userSecurityGroup?: SecurityGroups): boolean {
    if (!userSecurityGroup) {
      userSecurityGroup = this.tokenService.getSecurityGroup();
    }
    return SecurityGroupAuthorization.isUserAuthorized(userSecurityGroup, targetSecurityGroup);
  }
}
